const TipsSection = ({ tips, className = '' }) => (
  <div className={`mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg ${className}`}>
    <h3 className="font-semibold text-blue-800 mb-2">Tips for best results:</h3>
    <ul className="text-sm text-blue-700 space-y-1">
      {tips.map((tip, index) => (
        <li key={index}>• {tip}</li>
      ))}
    </ul>
  </div>
);

export default TipsSection;
